import virtualAccountApi from 'src/api/virtualAccountApi'
import useGetWithContext from './useGetWithContext'

const useGetPhoneClassInVirtual = (mgmtClassInAcctId) => {
  const { data: dataMgmt } = useGetWithContext(
    `GET_MGMT_ACCOUNT_${mgmtClassInAcctId}`,
    virtualAccountApi.getMgmtInAccount,
    mgmtClassInAcctId,
    { isDisabled: !mgmtClassInAcctId },
  )

  return {
    callingCode: dataMgmt?.countryCallingCode,
    phone: dataMgmt?.phone
  }
}
export default useGetPhoneClassInVirtual
